import { render } from "./CustomerCashback.vue?vue&type=template&id=166eee78&scoped=true"
import script from "./CustomerCashback.vue?vue&type=script&lang=js"
export * from "./CustomerCashback.vue?vue&type=script&lang=js"

import "./CustomerCashback.vue?vue&type=style&index=0&id=166eee78&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166eee78"]])

export default __exports__